import status from "../../../config/status.json";
import useCart from "./useCart";

export default function useStatusList(){

    const { cart } = useCart();

    if(!cart.category) return [];

    return status.filter(s => s.category === cart.category);
}